export default __webpack_public_path__ + "static/media/circle-one.51e68084.svg";